import React from 'react';
import clsx from 'clsx';

import { PROJECT_PATH, generateRoutePath } from '@/src/routes';

interface NoTaskProps {
  message?: string;
  showProcessesLink?: boolean;
  projectId?: string | number;
}

const NoTask: React.FC<NoTaskProps> = ({
  message = 'You’re all caught up.',
  showProcessesLink = false,
  projectId,
}) => {
  let processesUrl = '';
  if (showProcessesLink && projectId) {
    const base = generateRoutePath(PROJECT_PATH, { projectId });
    processesUrl = base.endsWith('/') ? `${base}processes` : `${base}/processes`;
  }
  return (
    <div
      className={clsx(
        'tw-flex',
        'tw-flex-col',
        'tw-items-center',
        'tw-justify-center',
        'tw-h-40',
        'tw-py-[200px]',
        'tw-px-[50px]'
      )}
    >
      <p className={clsx('tw-text-md', 'tw-text-gray-500', 'tw-font-semibold')}>{message}</p>
      {showProcessesLink && processesUrl && (
        <p className={clsx('tw-text-md', 'tw-text-gray-500', 'tw-mt-2', 'tw-text-center')}>
          You can visit{' '}
          <a
            href={processesUrl}
            className="tw-text-cfo-blue-600 tw-underline hover:tw-text-cfo-blue-800"
            target="_blank"
            rel="noopener noreferrer"
          >
            Processes
          </a>{' '}
          page to check on your team’s tasks.
        </p>
      )}
    </div>
  );
};

export default NoTask;
